module.exports = __webpack_public_path__ + "img/pose-recognition.b1983c27.png";